module.exports = __webpack_public_path__ + "static/media/item-13.17dd3677.png";